{
    "gender": {
        "man": "Man",
        "woman": "Woman",
        "other": "Other",
        "preferNotToSay": "Prefer not to say",
        "null": ""
    }
}
